import { Outlet } from 'react-router-dom'
import { Toaster } from '@/components/ui/toaster'

import { useToast } from '@/components/ui/use-toast'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'
import { ScrollRestoration } from 'react-router-dom'

// import { useEffect } from 'react'
// import { useLocation } from 'react-router-dom'

// const useScrollRestoration = () => {
//   const location = useLocation()

//   useEffect(() => {
//     if ('scrollRestoration' in window.history) {
//       window.history.scrollRestoration = 'manual'
//     }

//     const storedScrollPosition = sessionStorage.getItem(location.key)
//     if (storedScrollPosition) {
//       window.scrollTo(0, parseInt(storedScrollPosition, 10))
//     }

//     return () => {
//       console.log('ret', location.pathname, window.scrollY.toString())
//       sessionStorage.setItem(location.pathname, window.scrollY.toString())
//     }
//   }, [location])
// }

export default function RootLayout() {
  const { t } = useTranslation()
  const { toast } = useToast()
  const [searchParams, setSearchParams] = useSearchParams()
  // useScrollRestoration()

  useEffect(() => {
    if (searchParams.get('user_verification') === 'success') {
      toast({
        title: t('login.user_verification_success'),
      })

      searchParams.delete('user_verification')
      setSearchParams(searchParams)
    }
  }, [searchParams, setSearchParams, toast, t])
  return (
    <>
      <div className="root-layout">
        <Outlet />
        <Toaster />
        <ScrollRestoration
          getKey={(location) => {
            return location.pathname
          }}
        />
      </div>
    </>
  )
}
